import { FormSection, RenderEditOptions } from "components/MainSectionTemplate/types";
import { YesNoRadioGroupForInPageEditing, YesNoText } from "components/ValidatedFields/YesNoRadioGroup";
import React from "react";
import { getUpdateInstruction, WebformFormState } from "./model";
import { OptionalTextAreaTranslationValueInput, TranslationValueReadonly } from "./TranslationValueInnerForm";

export const dataProcessingDisclaimerSection = (
  webformFormState: WebformFormState,
): FormSection => ({
  key: "dataProcessingDisclaimer",
  title: RESX.DataProcessingDisclaimer.Header,
  type: "collapsable",
  fields: [{
    key: "displayDataProcessingDisclaimer",
    label: RESX.GeneralLabels.Display,
    render: () => <YesNoText value={webformFormState.displayDataProcessingDisclaimer} />,
    inPageEdit: {
      render: ({ value, onChange }: RenderEditOptions<boolean>) => <YesNoRadioGroupForInPageEditing
        value={value}
        onChange={v => onChange(v, true)}
      />,
      fullWidth: true,
      type: "custom",
      initialValue: webformFormState.displayDataProcessingDisclaimer,
      submitChange: (displayDataProcessingDisclaimer: boolean) => window.CoreApi.WebformConfiguration.UpdateDetails({
        ...getUpdateInstruction(webformFormState),
        displayDataProcessingDisclaimer,
      }),
    }
  }, {
    key: "dataProcessingDisclaimerText",
    hidden: !webformFormState.displayDataProcessingDisclaimer,
    isEmpty: webformFormState.dataProcessingDisclaimerText.length === 0,
    label: RESX.DataProcessingDisclaimer.DisclaimerText,
    render: () => <TranslationValueReadonly values={webformFormState.dataProcessingDisclaimerText} />,
    inPageEdit: {
      render: ({ value, onChange, submit, isSaving }: RenderEditOptions<server.dto.TranslationValue[]>) => <OptionalTextAreaTranslationValueInput
        submit={submit}
        onChange={onChange}
        values={value}
        isSaving={isSaving}
      />,
      fullWidth: true,
      type: "custom",
      initialValue: webformFormState.dataProcessingDisclaimerText,
      submitChange: (dataProcessingDisclaimerText: server.dto.TranslationValue[]) => window.CoreApi.WebformConfiguration.UpdateDetails({
        ...getUpdateInstruction(webformFormState),
        dataProcessingDisclaimerText,
      }),
    }
  }]
});